<template>
  <div class="filters">
    <v-btn-toggle v-model="activeFilters" borderless multiple>
      <v-btn
        :value="categories.studio.type"
        :disabled="!studioEnabled"
        :class="{ 'v-btn--blocked': lastFilterActive(categories.studio.type) }"
        class="v-btn--studio"
      >
        <v-icon v-if="isFilterActive(categories.studio.type)" left
          >mdi-label</v-icon
        >
        <v-icon v-else left>mdi-label-outline</v-icon>
        <span>Estúdio</span>
      </v-btn>

      <v-btn
        :value="categories.vt.type"
        :disabled="!vtEnabled"
        :class="{ 'v-btn--blocked': lastFilterActive(categories.vt.type) }"
        class="v-btn--vt"
      >
        <v-icon v-if="isFilterActive(categories.vt.type)" left
          >mdi-label</v-icon
        >
        <v-icon v-else left>mdi-label-outline</v-icon>
        <span>VT</span>
      </v-btn>

      <v-btn
        :value="categories.live.type"
        :disabled="!liveEnabled"
        :class="{ 'v-btn--blocked': lastFilterActive(categories.live.type) }"
        class="v-btn--live"
      >
        <v-icon v-if="isFilterActive(categories.live.type)" left
          >mdi-label</v-icon
        >
        <v-icon v-else left>mdi-label-outline</v-icon>
        <span>Ao Vivo</span>
      </v-btn>

      <v-btn
        :value="categories.screen.type"
        :disabled="!screenEnabled"
        :class="{ 'v-btn--blocked': lastFilterActive(categories.screen.type) }"
        class="v-btn--screen"
      >
        <v-icon v-if="isFilterActive(categories.screen.type)" left
          >mdi-label</v-icon
        >
        <v-icon v-else left>mdi-label-outline</v-icon>
        <span>Telão</span>
      </v-btn>

      <v-btn
        :value="categories.others.type"
        :disabled="!othersEnabled"
        :class="{ 'v-btn--blocked': lastFilterActive(categories.others.type) }"
        class="v-btn--others"
      >
        <v-icon v-if="isFilterActive(categories.others.type)" left
          >mdi-label</v-icon
        >
        <v-icon v-else left>mdi-label-outline</v-icon>
        <span>Outros</span>
      </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { categories } from '@/utils/mirrorFormatter.js';

export default {
  props: {
    studioEnabled: Boolean,
    vtEnabled: Boolean,
    liveEnabled: Boolean,
    screenEnabled: Boolean,
    othersEnabled: Boolean,
  },
  data() {
    return {
      categories,
    };
  },
  computed: {
    activeFilters: {
      get() {
        return this.$store.state.mirror.activeFilters;
      },
      set(payload) {
        this.$store.commit('mirror/SET_ACTIVE_FILTERS', payload);
      },
    },
  },
  methods: {
    lastFilterActive(filterType) {
      if (!this.activeFilters) return null;

      return (
        this.activeFilters.length === 1 &&
        this.activeFilters.indexOf(filterType) >= 0
      );
    },
    isFilterActive(filterType) {
      return this.activeFilters.includes(filterType);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme-v2.scss';

.filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin: 0 0 16px 0;
  padding: 0;
  background-color: $color-white;
  border-top: solid 1px $color-black-08;

  ::v-deep .v-btn-toggle {
    display: flex;
    overflow-x: auto;
    width: 100%;
    padding: 16px;
    background-color: $color-white;

    &::-webkit-scrollbar {
      display: none;
    }

    .v-btn {
      min-width: 0;
      height: 40px !important;
      margin: 0 4px;
      padding: 0 8px;
      border-radius: 4px;
      background-color: $color-black-08 !important;
      font-size: 0.8em !important;
      text-transform: lowercase;
      color: $color-black-40;
      letter-spacing: 0;
      opacity: 1;
      transition: all 0.4s ease-in-out;

      // Remoção da layer que deixa a cor dos btns opaca
      &::before {
        display: none;
      }

      // Ajustes nas margens
      &:first-child {
        margin: 0 4px 0 0;
      }

      &:last-child {
        margin: 0 0 0 4px;
      }
      //----
      //----

      i {
        color: $color-white !important;
        margin: 0 4px 0 0;
      }

      // Cores de categorias
      &.v-btn--live {
        .v-icon {
          color: $status-live !important;
        }
      }
      &.v-btn--vt {
        .v-icon {
          color: $status-vt !important;
        }
      }
      &.v-btn--studio {
        .v-icon {
          color: $status-studio !important;
        }
      }
      &.v-btn--screen {
        .v-icon {
          color: $status-screen !important;
        }
      }
      &.v-btn--others {
        .v-icon {
          color: $status-others !important;
        }
      }

      &.v-btn--active {
        color: $color-black-64;
        font-family: 'globotipo' !important;
        font-weight: 500 !important;
        background-color: $color-white !important;
        box-shadow: 0 4px 8px rgba($color-black, 0.08);
        transition: all 0.4s ease-in-out;

        // Cores de categorias
        &.v-btn--live {
          .v-icon {
            color: $status-live !important;
          }
        }
        &.v-btn--vt {
          .v-icon {
            color: $status-vt !important;
          }
        }
        &.v-btn--studio {
          .v-icon {
            color: $status-studio !important;
          }
        }
        &.v-btn--screen {
          .v-icon {
            color: $status-screen !important;
          }
        }
        &.v-btn--others {
          .v-icon {
            color: $status-others !important;
          }
        }

        &.v-btn--blocked {
          pointer-events: none;
          opacity: 0.64;
        }
      }

      &.v-btn--disabled {
        background-color: $color-black-64 !important;
        pointer-events: none;
        opacity: 0.48;
      }
    }
  }
}
</style>
